<div class="panel-content bg-background h-full flex flex-col gap-3">
    <div class="py-6 px-8 field-intervention-header bg-white rounded-xl justify-between">
        <app-title
            [title]="fieldInterventionBloc.value()!.name"
            (goToPreviousPage)="goToPreviousPage()" />

        @if (!updateMode()) {
            <app-button
                iconSize="sm"
                [disabled]="!hasManageFieldInterventionPermission()"
                [icon]="['fas', 'pen']"
                [label]="'updatePlanning' | transloco"
                [type]="ButtonType.SECONDARY"
                (onClick)="updateMode.set(!updateMode())" />
        } @else {
            <app-button
                iconSize="sm"
                [disabled]="!entitiesTableByLayerService.selectedLayerNumber()"
                [icon]="['fas', 'timeline-arrow']"
                [label]="'update' | transloco"
                [type]="ButtonType.PRIMARY"
                (onClick)="openPlanningModal()" />
        }
    </div>
    <div class="bg-background flex flex-col grow min-h-0 w-full">
        @if (entitiesTableByLayerService.layerNames().length && this.defaultTableIndex() >= 0) {
            <div class="flex-1 min-h-0 w-full">
                <app-tab
                    [defaultTabIndex]="defaultTableIndex()"
                    [tabs]="tabs()"
                    [translateTabs]="false"
                    (changeTab)="changeTab($event)">
                    @for (layerName of entitiesTableByLayerService.layerNames(); track layerName) {
                        <ng-template appTabContent>
                            @if (entitiesTableByLayerService.areLayersDefined()) {
                                <div class="flex overflow-y-scroll">
                                    <app-field-intervention-entities-list
                                        class="w-full h-full"
                                        [canSelect]="updateMode()"
                                        [currentLayers]="entitiesTableByLayerService.layersByName()![layerName]" />
                                </div>
                            } @else {
                                <div class="bg-white h-full w-full flex items-center justify-center m-auto">
                                    <app-no-data-to-display [iconSize]="'5x'" />
                                </div>
                            }
                        </ng-template>
                    }
                </app-tab>
            </div>
            <div class="px-5 pb-5 bg-white">
                <app-field-intervention-entities-list-footer
                    disableReason="noModifiedEntities"
                    [activeLayers]="entitiesTableByLayerService.activeLayers()"
                    [canExecuteAction]="updateMode()"
                    [canSearch]="true"
                    [disable]="!updateFieldInterventionService.updatedEntities().length"
                    [paginationParameters]="entitiesTableByLayerService.paginationParameters()"
                    [primaryButtonProps]="{ labelKey: 'submitModifications', icon: ['fas', 'check'] }"
                    [selectedEntitiesNumber]="
                        updateMode() ? entitiesTableByLayerService.selectedEntitiesNumber() : undefined
                    "
                    [selectedLayerNumber]="updateMode() ? entitiesTableByLayerService.selectedLayerNumber() : undefined"
                    [totalEntities]="entitiesTableByLayerService.totalItemsCurrentLayer()"
                    [updatedEntityNumber]="
                        updateMode() ? updateFieldInterventionService.updatedEntities().length : undefined
                    "
                    (onPrimaryButtonClick)="savePlanUpdate()"
                    (paginator)="onPaginatorChange($event)" />
            </div>
        } @else {
            <div class="bg-white h-full flex items-center justify-center">
                <app-no-data-to-display [iconSize]="'5x'" />
            </div>
        }
    </div>
</div>
